import { EventAggregator } from 'aurelia-event-aggregator';
import { autoinject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { Models } from 'models/core';
import { ErrorService } from 'services/error-service';
import { MarkingTypeService } from 'services/marking-type-service';
import { ToastService } from 'services/toast-service';

@autoinject
export class MarkingTypeList {
  private tableData: Array<Models.MarkingType>;
  private activeTableRow: number;

  private constructor(
    private errorService: ErrorService,
    private eventAggregator: EventAggregator,
    private router: Router,
    private toastService: ToastService,
    private markingTypeService: MarkingTypeService
  ) {}

  private activate(params) {
    if (params.Id) {
      this.activeTableRow = params.Id;
    } else {
      this.activeTableRow = 0;
    }
  }

  private attached(params) {
    this.eventAggregator.subscribe('markingTypeListReset', (value) => {
      this.activeTableRow = null;
      return this.updateView();
    });
    this.updateView();
  }

  private updateView() {
    this.markingTypeService
      .getAll('?$orderby=Name&$expand=NavisionProduct,DeltaProduct')
      .then((res) => {
        this.tableData = res;
      })
      .catch((err) => this.errorService.handleError(err));
  }

  private gotoDetailView(id) {
    this.activeTableRow = id;
    this.router.navigateToRoute('marking-type-detail', { Id: id });
  }
}
